/**
 * Displays animated info messages that slide up from the bottom of the screen and messages automatically hide after a pause period.
 */
function infoMessage() {
    const messageSelector = '.shopwired-info-message';
    if (!$(messageSelector).length) {
        return;
    }

    const settings = {
        pause: 4400,
        animationSpeed: 400
    };
    const bottom = '-' + $(messageSelector).outerHeight(false) + 'px';

    $(messageSelector)
        .stop(true, true)
        .css({
            opacity: 1,
            bottom: bottom,
            display: 'block'
        }).animate({
        bottom: 0
    }, settings.animationSpeed).delay(settings.pause).animate({
        bottom: bottom
    }, settings.animationSpeed, function () {
        $(messageSelector).hide();
    });
}

export {infoMessage};
